import React from 'react';

export default function FormShell({ title, subtitle, icon, children, className = '', headerClassName = 'p-4 sm:p-5', bodyClassName = 'p-4 sm:p-6 lg:p-8', titleClassName = 'text-base sm:text-lg', subtitleClassName = '', iconWrapClassName = 'w-9 h-9', box, divide, textPri, textMuted }) {
  return (
    <div className={`rounded-2xl shadow-sm border overflow-hidden w-full ${box} ${className}`}>
      {(title || subtitle) && (
        <div className={`border-b ${headerClassName} ${divide}`}>
          <div className="flex items-center gap-3">
            {icon && (
              <div className={`${iconWrapClassName} rounded-xl flex items-center justify-center shrink-0 bg-[#1F80FF] text-white`}>
                {icon}
              </div>
            )}
            <div>
              {title && <h2 className={`font-semibold ${titleClassName} ${textPri || ''}`}>{title}</h2>}
              {subtitle && <p className={`text-xs mt-0.5 ${textMuted || 'opacity-70'} ${subtitleClassName}`}>{subtitle}</p>}
            </div>
          </div>
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
    </div>
  );
}
